import React from 'react';
import omit from 'lodash/omit';
import {
  Field,
  useFormikContext,
  useField,
} from 'formik';

import FieldSummernote from './FieldSummernote.jsx';
import FieldFileCoverImg from './FieldFileCoverImg.jsx';
import FieldFileSlider from './FieldFileSlider.jsx';
import FieldFileInput from './FieldFileInput.jsx';
import FieldDayPicker from './FieldDayPicker.jsx';
import FieldDayRangePicker from './FieldDayRangePicker.jsx';
import FieldFileUpload from './FieldFileUpload.jsx';

const FormField = (props) => {
  const {
    name,
    affirm,
    as,
  } = props;
  const {
    validateOnMount,
  } = useFormikContext();
  const [, { error, touched }] = useField(name);

  if (!validateOnMount && affirm) {
    console.error('"validateOnMount" is necessary for the "affirm" property');
  }

  // get className
  const c = [
    as === 'select' ? 'custom-select' : 'form-control',
    props.className,
    error && touched ? 'is-invalid' : '',
    as === 'file' ? 'h-auto' : '',
  ];

  if (touched && error) {
    c.push('is-invalid');
  }
  if (affirm && !error) {
    c.push('is-valid');
  }

  const className = c.filter((s) => s).join(' ');
  const p = {
    ...omit(props, ['affirm']),
    className,
  };

  if (as === 'summernote') {
    return <FieldSummernote {...p} />;
  }
  if (as === 'coverImg') {
    return <FieldFileCoverImg {...p} />;
  }
  if (as === 'slider') {
    return <FieldFileSlider {...p} />;
  }
  if (as === 'file') {
    return <FieldFileInput {...p} />;
  }
  if (as === 'daypicker') {
    return <FieldDayPicker {...p} />;
  }
  if (as === 'dayrangepicker') {
    return <FieldDayRangePicker {...p} />;
  }
  if (as === 'upload') {
    return <FieldFileUpload {...p} />;
  }

  return <Field {...p} />;
};

export default FormField;
